<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('data.card_verification_list') }}
    </div>
    <CardVerificationDetails />
  </div>
</template>

<script>
export default {
  name: 'Data_Card_Verification',
  components: {
    CardVerificationDetails: () => import('./components/CardVerificationDetails.vue')
  }
}
</script>

<style scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
